window.slate = window.slate || {};
window.theme = window.theme || {};

$ = jQuery;

$(document).ready(function() {
  var imageSliderID = "amb_home_hero_slider_1";
  setTimeout(function() {
    imageSliderID = new Swiper('#amb-home-hero-slider-1', {
      autoplayDisableOnInteraction: false,
      paginationClickable: true,
      keyboardControl: true,
      slidesPerView: 1,
      autoplay: false,
      effect: "fade",
      fade: {
        crossFade: true
      },
    });
  }, 100);
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE "); /* If Internet Explorer, return version number */
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    setTimeout(function() {
      $(document).imagesLoaded(function() {
        if ($('#amb-home-hero-slider-1').length > 0) {
          imageSliderID.onResize();
        }
      });
    }, 300);
  }
  $(window).resize(function() {
    setTimeout(function() {
      if ($('#amb-home-hero-slider-1').length > 0) {
        imageSliderID.onResize();
      }
    }, 500);
  });
  $('.flexslider').flexslider({
    animation: "fade"
  });
});
$(document).ready(function() {
  var textSliderID = "text_slider_2";
  setTimeout(function() {
    textSliderID = new Swiper('#text-slider-2', {
      nextButton: '.swiper-next-3',
      prevButton: '.swiper-prev-3',
      loop: true,
      autoplay: false,
    });
  }, 100);
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE "); /* If Internet Explorer, return version number */
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    setTimeout(function() {
      $(document).imagesLoaded(function() {
        if ($('#text-slider-2').length > 0) {
          textSliderID.onResize();
        }
      });
    }, 300);
  }
  $(window).resize(function() {
    setTimeout(function() {
      if ($('#text-slider-2').length > 0) {
        textSliderID.onResize();
      }
    }, 500);
  });
  KlaviyoSubscribe.attachToForms('#mc-embedded-subscribe-form', {
    hide_form_on_success: true,
  });
});
